module.exports = __webpack_public_path__ + "img/sp3.efcd7580.png";